import RouteView from '@/router/RouteView.vue';
import putOn from './putOn/index.vue'; // 课程上架
import addCourse from './addCourse/index.vue'; // 新增课程
import editClassHours from './editClassHours/index.vue';
import courseList from './courseList/index.vue';
import volumeAuth from './volumeAuth/index.vue';

export default [
  {
    path: '/putOn',
    name: 'putOn',
    component: putOn,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/putOn',
    component: RouteView,
    meta: {
      title: '课程列表',
    },
    children: [
      {
        path: '/putOn/addCourse',
        name: 'addCourse',
        component: addCourse,
        meta: {
          title: '新增课程',
        },
      },
      {
        path: '/putOn/editClassHours',
        name: 'editClassHours',
        component: editClassHours,
        meta: {
          title: '课时编辑',
        },
      },
      {
        path: '/putOn/courseList',
        name: 'courseList',
        component: courseList,
        meta: {
          title: '课时编辑',
        },
      },
      {
        path: '/putOn/volumeAuth',
        name: 'volumeAuth',
        component: volumeAuth,
        meta: {
          title: '课程批量授权',
        },
      },
    ],
  },
];


// WEBPACK FOOTER //
// ./src/views/CourseOn/router.js